import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import AhPwdlessCommonsUtility from "utilities/login/ah-pwdless-common-utility/1.0.0/js/ah-pwdless-common-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import ahInputValidationUtility from "utilities/login/ah-input-validation-utility/1.0.0/js/ah-input-validation-utility";
import ahModalUtility from "utilities/login/ah-modal-utility/2.0.0/js/ah-modal-utility";
import ahPubsubUtility from "utilities/login/ah-pubsub-utility/2.0.0/js/ah-pubsub-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import spartaTemplates from "modules/login/ah-di-module/2.0.1/js/templates";
import "css!modules/login/ah-di-module/2.0.1/css/ah-di-module.scss.css";

let polling = false;
let diDenyMessage = false;
let isDigitalUser = false;
export default class ahDiView {
    constructor(parentModule) {
        this.parentModule = parentModule;
        const self = this;
        this.bindThisContext(['initialize'],
            self, '');
    }

    bindThisContext(methods, context, suffix = 'Scoped') {
        const self = context;

        if (methods && $.isArray(methods) && methods.length > 0) {
            $(methods).each((index, method) => {
                if (self[method]) {
                    self[method + suffix] = self[method].bind(context);
                } else {
                    console.log(`Method: ${method} Not found in current context.`);
                }
            });
        }
    }

    _defineVars() {
        const _view = this.parentModule.view;
        this.$moduleContext = $(_view.settings.target);

        const elementsID = {
            'main-container': 'ah-di-container',
            signinMainContent: 'sign-in-main-content',

            saveOnlineID: 'saveOnlineID',
            errorTarget: 'error-target',
            oidTxtBox: 'oid',
            oidPass: 'pass',
            genericErrorSigninSection: 'generic-error-signin-section',
            genericErrorSigninClose: 'generic-error-signin-close',
            signinWithMobileAppLink: 'signin-with-mobile-app-link',
            signinWithMobileAppLinkText: 'signin-with-mobile-app-link-text',
            signInWithMobileApp: 'signin-with-mobile-app',
            signInWithMobileAppButton: 'signin-with-mobile-app-button',
            mobileDeviceNotificationText: 'mobile-device-notification-text',
            sendNotificationAgain: 'send-notification-again',
            sendNotificationAgainText: 'send-notification-again-text',
            signInWithPasscode: 'signin-with-passcode',
            signInWithPasscodeText: 'signin-with-passcode-text',
            signinWithPasscodeInstead: 'signin-with-passcode-instead',
            signinWithPasscodeTextInstead: 'signin-with-passcode-text-instead',
            mobileDeviceGenericNotificationText: 'mobile-device-generic-notification-text',
            mobileDeviceMaximumAttemptNotificationText: 'mobile-device-maximum-attempt-notification-text',
            passCodeField: 'passCodeField',
            forgotOidPass: 'caw-forgot',
            iaValue: '_ia',
            dropDownOid: 'prefill-oid',
            signIn: 'caw-signin',
            forgotOidPasscode: 'forgot-oid-pass',
            enroll: 'secure-signin-enroll',
            signinSubmit: 'secure-signin-submit'
        };

        const elementsClass = {
            'save-id-wrapper': 'save-id-wrapper',
            'oid-input-wrapper': 'oid-input-wrapper',
            'prefill-oid-wrapper': 'prefill-oid-wrapper'
        };
        this.elementsSelectors = {};

        $.each(elementsID, (i, val) => {
            this.elementsSelectors[i] = `#${val}`;
        });
        $.each(elementsClass, (i, val) => {
            this.elementsSelectors[i] = `.${val}`;
        });
        return this;
    }

    _bindEventHandlers() {
            const main = this.parentModule;
            const that = this;

    const prefillOidDropDown =  $('.prefill-oid-wrapper').find('select');
    prefillOidDropDown.off('change.redraw').on('change.redraw', () => {
        main.Events.pub("diChangeOid", "");
    });

             $('#signin-with-passcode-text')
                .off('click')
                .on('click', () => {

                                   this._handleSigninwithPasscodeClick();
                  main.Events.pub("Handle_Signin_With_Passcode_clicked","true");
                });

              $('#send-notification-again-text')
                   .off('click')
                    .on('click', () => {
                      this.handleSendNotificationAgain();
                    });

                    this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeTextInstead).off('click')
                 .on('click', () => {

                                   this._handleSigninwithPasscodeClick();
                   main.Events.pub("Handle_Signin_With_Passcode_clicked","true");
                 });

                 $('#signin-with-passcode-text-instead').off('click')
                 .on('click', () => {

                                   this._handleSigninwithPasscodeClick();
                   main.Events.pub("Handle_Signin_With_Passcode_clicked","true");
                 });

				             $('#signin-with-passcode-link')
			.off('click')
			.on('click', () => {

                       this._handleSigninwithPasscodeClick();
               main.Events.pub("Handle_Signin_With_Passcode_clicked","true");
            });			

			            return this;
        }

        submitLoader(state = 'show') {
          const submitButton = document.getElementById('mobile-device-notification-text');
          if (state === 'show') {
            submitButton.classList.add('loading');
          } else {
            submitButton.classList.remove('loading');
          }
        }

        _triggerPollingService(){
          const main = this.parentModule;
          const pollingUrl = main.apiEndPoints.pollingUrl;
          const ajaxOptions = {
          method: 'GET',
          url: pollingUrl,
          crossDomain: true,
          cache: false,
          timeout: 60000,
          processData: false,
          xhrFields: {
              withCredentials: true,
          },
          dataType: 'json',
          headers: {
              'content-type': 'application/json',
              clientAIT: '41339',
              accept: 'application/json',
              'cache-control': 'no-cache',
          },
      };

      const initiateCall = new ahCawTransportUtility();
        if(polling){
      initiateCall._serviceCall(ajaxOptions, (response) => {
        const data = response.responseData;
        main.Events.pub("Show_Di_Message", "true");

        if (data && data.Completion.value && data.Completion.value === 'PENDING') {
          this.submitLoader('show');
          diDenyMessage = false;
          document.getElementById("caw-signin").classList.add('hidden');
          if(document.getElementById("xid-signin")){
            document.getElementById("xid-signin").classList.add('hidden');
           }
          document.getElementById("pass").parentNode.classList.add('hidden');
          document.getElementById("saveOnlineID").parentNode.classList.add('hidden');
          document.getElementById("oid").parentNode.parentNode.classList.add('hidden');
          document.getElementById("signin-with-mobile-app-link").classList.add('hidden');
          document.getElementById("prefill-oid").parentNode.classList.add('hidden');
          document.getElementById("signin-with-mobile-app").classList.add('hidden');
          document.getElementById("signin-with-passcode").classList.add('hidden');
          this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).removeClass('hidden');


          document.getElementById("mobile-device-notification-text").classList.remove('hidden');
          document.getElementById("mobile-device-maximum-attempt-notification-text").classList.add('hidden');
          document.getElementById("send-notification-again").classList.remove('hidden');
          document.getElementById("mobile-device-generic-notification-text").classList.add('hidden');
          document.getElementById("ah-di-container").classList.remove('hidden');
          if(document.getElementById("caw-forgot")){
            document.getElementById("caw-forgot").classList.add('hidden');
          }

                    setTimeout(() => {

            this._triggerPollingService();
          }, 5000);
        } else if (data && data.Completion.value && data.Completion.value === 'ALLOW'){
          main.Events.pub("Di_Auth_Success", "true");


        } else if ((data && data.Completion.value && data.Completion.value === 'DENY')||(data && data.Completion.value && data.Completion.value === 'FAILED')){
          diDenyMessage = true;
          document.getElementById("caw-signin").classList.add('hidden');
          if(document.getElementById("xid-signin")){
            document.getElementById("xid-signin").classList.add('hidden');
           }
          document.getElementById("pass").parentNode.classList.add('hidden');
          document.getElementById("saveOnlineID").parentNode.classList.add('hidden');
          document.getElementById("oid").parentNode.parentNode.classList.add('hidden');
          document.getElementById("signin-with-mobile-app-link").classList.add('hidden');
          document.getElementById("prefill-oid").parentNode.classList.add('hidden');
          document.getElementById("signin-with-mobile-app").classList.add('hidden');
          document.getElementById("signin-with-passcode").classList.add('hidden');
          this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).removeClass('hidden');

          document.getElementById("mobile-device-notification-text").classList.add('hidden');
          document.getElementById("mobile-device-maximum-attempt-notification-text").classList.remove('hidden');
          document.getElementById("send-notification-again").classList.add('hidden');
          document.getElementById("mobile-device-generic-notification-text").classList.add('hidden');
          document.getElementById("ah-di-container").classList.remove('hidden');
          if(document.getElementById("caw-forgot")){
            document.getElementById("caw-forgot").classList.add('hidden');
          }
        }

        });
      }
        }
        _triggerPostAuthService(){
          const main = this.parentModule;
          const postAuthUrl = main.apiEndPoints.postAuthUrl;
          const ajaxOptions = {
          method: 'GET',
          url: postAuthUrl,
          crossDomain: true,
          cache: false,
          timeout: 60000,
          processData: false,
          xhrFields: {
              withCredentials: true,
          },
          dataType: 'json',
          headers: {
              'content-type': 'application/json',
              accept: 'application/json',
              'cache-control': 'no-cache',
          },
      };
      const initiateCall = new ahCawTransportUtility();
      initiateCall._serviceCall(ajaxOptions, (response) => {
        const data = response.responseData;
        window.location.replace(data.return2Url);
        });
        }

        _triggerInitAuth2() {

                    const main = this.parentModule;
          const initAuthURL2 = main.apiEndPoints.initAuthUrl2;
          const dropDownOptionElem = document.getElementById("prefill-oid");
          let iaValue = "";
          if (window.boa && window.boa.fingerprint) {
            window.boa.fingerprint.prepareIAData((IAData) => {
                iaValue = IAData;
            });
        }
          let selectedID = "";
          if (dropDownOptionElem.options[dropDownOptionElem.selectedIndex]){
            selectedID = dropDownOptionElem.options[dropDownOptionElem.selectedIndex].text;
          }
          const selectedIDIndex = dropDownOptionElem.selectedIndex;
          const checkOnlineIDSaved = main.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
          const oid =document.getElementById("oid").value;
          const  JSEncrypt  =  new  JSEncryptExports.JSEncrypt();
          JSEncrypt.setPublicKey(main.diPublicKey);
          const encryptedOid = JSEncrypt.encrypt(oid);
          const validOid = $('#oid');
          const isValid = spartaValidationFramework.fn.core.validateRequiredFields(validOid);
          const prefillOidDropDown =   $('.prefill-oid-wrapper').find('select');
          const isOnlineIDHidden = document.getElementById("oid").parentNode.parentNode.classList.contains('hidden');


          let OnlineIDSaved = 'false';
          if (document.getElementById('saveOnlineID').checked === true) {
            OnlineIDSaved = 'true';
          }
           if (!isOnlineIDHidden && !isValid) {
               let useCaseVal = main.Store.getData('widgetConfigData').usecase;
              return isValid;
           }
          let inputJson = {
             tokenSets: [
               {
                 value: selectedIDIndex,
                 type: "OID_INDEX"
             }
           ],
           processRules: [
             {
              value: "OnlineIDPwd",
              name: "AuthenticationContext"
          },
          {
              value: iaValue,
              name: "_ia"
          },
          {
              value: OnlineIDSaved,
              name: "SAVE_ONLINE_ID"
          }
         ],
            filterRules: [
                    {
                        value: "FlagScape",
                        name: "CLIENT"
                    },
                    {
                        value: "WEB",
                        name: "SOURCE"
                    }
                  ]
           };

           if (!selectedID || (prefillOidDropDown.find('option:selected').val() === 'manual-oid')){
             inputJson.tokenSets[0].value = encryptedOid;
             inputJson.tokenSets[0].type = "ONLINE_ID";
           }
                  const ajaxOptions = {
                  method: 'POST',
                  data: JSON.stringify(inputJson),
                  url: initAuthURL2,
                  crossDomain: true,
                  cache: false,
                  timeout: 60000,
                  processData: false,
                  xhrFields: {
                      withCredentials: true,
                  },
                  dataType: 'json',
                  headers: {
                      'content-type': 'application/json',
                      clientAIT: '41339',
                      accept: 'application/json',
                      'cache-control': 'no-cache',
                  },
              };
                  const initiateCall = new ahCawTransportUtility();
                  initiateCall._serviceCall(ajaxOptions, (response) => {
                    document.getElementById("send-notification-again-text").classList.add('spa-btn--default');
                    document.getElementById("send-notification-again-text").classList.remove('spa-btn--disabled');
                    const data = response.responseData;
                    if((data && data.errorCode && data.errorCode === 'E0001')||(data && data.errorCode && data.errorCode === 'GENERAL_AUTH_ERROR')||(data && data.Completion.value && data.Completion.value === 'DENY')){
                      if (data.Completion && data.Completion.value === 'DENY'){
                       polling = false;
                      }
                      main.Events.pub("Show_Di_Message", "true");
                     diDenyMessage = true;
                     document.getElementById("caw-signin").classList.add('hidden');
                     if(document.getElementById("xid-signin")){
                      document.getElementById("xid-signin").classList.add('hidden');
                     }

                                         document.getElementById("pass").parentNode.classList.add('hidden');
                     document.getElementById("saveOnlineID").parentNode.classList.add('hidden');
                     document.getElementById("oid").parentNode.parentNode.classList.add('hidden');
                     document.getElementById("signin-with-mobile-app-link").classList.add('hidden');
                     document.getElementById("prefill-oid").parentNode.classList.add('hidden');
                     document.getElementById("signin-with-mobile-app").classList.add('hidden');
                     document.getElementById("signin-with-passcode").classList.add('hidden');
                     this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).removeClass('hidden');

                     document.getElementById("mobile-device-notification-text").classList.add('hidden');
                     document.getElementById("mobile-device-maximum-attempt-notification-text").classList.remove('hidden');
                     document.getElementById("send-notification-again").classList.add('hidden');
                     document.getElementById("mobile-device-generic-notification-text").classList.add('hidden');
                     document.getElementById("ah-di-container").classList.remove('hidden');
                     if(document.getElementById("caw-forgot")){
                      document.getElementById("caw-forgot").classList.add('hidden');
                    }
                } else if (data && data.Completion.value && data.Completion.value === 'SUCCESS'){
                  polling = true;
                this._triggerPollingService();
                }
        });
        }

      _handleSigninwithPasscodeClick(){
            polling = false;
            const main = this.parentModule;
            let widgetInfo = main.Store.getData('widgetConfigData');
            const prefillOidDropDown = $('.prefill-oid-wrapper').find('select');
            const checkOnlineIDSaved = main.SpartaFunctions.spartaGetCookie('olb_signin_prefill_multi_secure').trim();
			const pwdlCookie = main.SpartaFunctions.spartaGetCookie('pwdl').trim();
            const secureSignInEnroll = document.getElementById("secure-signin-enroll");
            document.getElementById("pass").parentNode.classList.remove('hidden');
            document.getElementById("send-notification-again").classList.add('hidden');
            document.getElementById("signin-with-passcode").classList.add('hidden');
            document.getElementById("mobile-device-notification-text").classList.add('hidden');
           if(diDenyMessage){
            document.getElementById("signin-with-mobile-app-link").classList.add('hidden');
           } else {
                 document.getElementById("signin-with-mobile-app-link").classList.remove('hidden');
           }
              document.getElementById("signin-with-mobile-app").classList.add('hidden');
              document.getElementById("caw-signin").classList.add('cancel-signin');
              document.getElementById("caw-signin").classList.remove('hidden');

          if(document.getElementById('caw-signin').getElementsByClassName("secure-signin-submit")[0].closest('.float-left')){
              document.getElementById('caw-signin').getElementsByClassName("secure-signin-submit")[0].closest('.float-left').classList.remove('hidden');
           }

           if (checkOnlineIDSaved){
               if (prefillOidDropDown.find('option:selected').val() === 'manual-oid') {
                    document.getElementById("prefill-oid").parentNode.classList.add('hidden');
                    document.getElementById("oid").parentNode.parentNode.classList.remove('hidden');
                    document.getElementById("saveOnlineID").parentNode.classList.remove('hidden');

               } else {
                 if ((main.params && main.params.hideSavedID && main.params.hideSavedID === 'true') || (widgetInfo&&widgetInfo.showSaveOIDCheck && widgetInfo.showSaveOIDCheck ==='false' )) {
                    document.getElementById("prefill-oid").parentNode.classList.add('hidden');
                    document.getElementById("oid").parentNode.parentNode.classList.remove('hidden');
                    document.getElementById("saveOnlineID").parentNode.classList.remove('hidden');
                 } else {
                    document.getElementById("prefill-oid").parentNode.classList.remove('hidden');
                    document.getElementById("oid").parentNode.parentNode.classList.add('hidden');
                    document.getElementById("saveOnlineID").parentNode.classList.add('hidden');
                 }
               }

								if(main.ahPwdlessCommons._checkpwdlessEligibility("prefill-oid")){
					document.getElementById("signin-pwdless").classList.add('hidden');
					document.getElementById("sign-in-attempt-failed").classList.add('hidden');	
					document.getElementById("win-hello-off").classList.add('hidden');						
					document.getElementById("sign-in-main-content").classList.remove('hidden');	
					document.getElementById("signInPwdless-link").classList.remove('hidden');	
					if(document.getElementById("caw-forgot")){
            document.getElementById("caw-forgot").classList.remove('hidden');
          }

      if(isDigitalUser){
						document.getElementById("signin-with-mobile-app-link").classList.remove('hidden');
					}
					else{
						document.getElementById("signin-with-mobile-app-link").classList.add('hidden');
					}
				}

			              } else {
             document.getElementById("prefill-oid").parentNode.classList.add('hidden');
             document.getElementById("oid").parentNode.parentNode.classList.remove('hidden');
             document.getElementById("saveOnlineID").parentNode.classList.remove('hidden');
           }
           this.$moduleContext.find(this.elementsSelectors.signinWithPasscodeInstead).addClass('hidden');


            document.getElementById("mobile-device-maximum-attempt-notification-text").classList.add('hidden');
            document.getElementById("mobile-device-generic-notification-text").classList.add('hidden');
           if (secureSignInEnroll){
             secureSignInEnroll.parentNode.classList.add('hidden');
           }

          $("#oid").val("");
          $("#pass").val("");
          document.getElementById("oid_errorMessage").classList.add('hidden');
          document.getElementById("oid").classList.remove('spa-error-form-input--required');
          $('label[for=oid]').removeClass('spa-error-form-label--required');
          if(document.getElementById("caw-forgot")){
            document.getElementById("caw-forgot").classList.remove('hidden');
          }
       }

       handleSendNotificationAgain(){
         const that = this;
         document.getElementById("send-notification-again-text").classList.remove('spa-btn--default');
         document.getElementById("send-notification-again-text").classList.add('spa-btn--disabled');
         this._triggerInitAuth2();
       }

    _subscribeEvents() {
        const main = this.parentModule;
        const controller = this.parentModule.controller;
        main.Events.sub('handleMobileAppLink', (data) => {
             this._triggerInitAuth2();
        });
        main.Events.sub('handlePolling', (e) => {

             polling= e.data.polling;
        }, true);

        main.Events.sub(cawEventsMasterUtility.EVENTS.CAW_KEY, (data) => {
          main.diPublicKey = data.data;
        });
        main.Events.sub('Digital_User',(e)=>{
          isDigitalUser = e.data;
        });

        return this;
    }

    initialize() {
        this._defineVars()
            ._bindEventHandlers()
            ._subscribeEvents();

        const basePath = ahCawCommons.getBasePath(this.parentModule.spaParams);
        this.$moduleContext.find('[data-href]').each(function() {
            $(this).attr('href', basePath + $(this).attr('data-href'));
        });
    }

}
